import Model from "~~/package/mapper/Model";
import {createModel} from "~~/package/utils/ModelUtil";
import {LevelAssessmentResultModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentResultModel";

export class LevelAssessmentResultListModel extends Model {
    constructor(
        public isPass: boolean = true,
        public submitDate: string = "",
        public resultList: LevelAssessmentResultModel[] = []
    ) {
        super();
    }

    public static create(model: Partial<LevelAssessmentResultListModel>): LevelAssessmentResultListModel {
        return createModel<LevelAssessmentResultListModel>(LevelAssessmentResultListModel, {
            ...model
        });
    }
}
